module.exports = __webpack_public_path__ + "static/media/close.5db5fd73.svg";